/**
 * Los tres estados del tema y la mecanica minima para leerlos, guardarlos y
 * aplicarlos. Sin React a proposito: el mismo contrato lo usan el proveedor y
 * el script de arranque de `index.html`, que corre antes de que exista React.
 */

/**
 * OJO: los tres valores, la clave de `localStorage` y el valor por defecto
 * estan repetidos en el script de arranque de `index.html`, que corre antes de
 * que exista ningun modulo y por eso no puede importarlos. Si cambia algo de
 * esto, hay que cambiarlo alli tambien.
 */
export const TEMAS = ['sistema', 'claro', 'oscuro'] as const

export type Tema = (typeof TEMAS)[number]

/**
 * Oscuro por defecto, no `sistema`.
 *
 * Lo pidio quien pasa el dia delante de esta pantalla: "el blanco me satura
 * demasiado". Arrancar en `sistema` le obligaria a cambiarlo en cada navegador
 * y en cada ordenador desde los que entra, que es no haberle escuchado. Quien
 * prefiera seguir al sistema lo tiene a un clic.
 */
export const TEMA_POR_DEFECTO: Tema = 'oscuro'

/** Misma familia de claves que el token de sesion (`tactica.token`). */
export const CLAVE_TEMA = 'tactica.tema'

/** Atributo del elemento raiz. Es el que `graficos/paleta.ts` ya espera. */
export const ATRIBUTO_TEMA = 'data-theme'

export const ETIQUETAS: Record<Tema, string> = {
  sistema: 'Sistema',
  claro: 'Claro',
  oscuro: 'Oscuro',
}

export function esTema(valor: unknown): valor is Tema {
  return typeof valor === 'string' && (TEMAS as readonly string[]).includes(valor)
}

/**
 * El tema guardado, o el de por defecto. Cualquier fallo de `localStorage`
 * -modo privado de Safari, almacenamiento bloqueado por politica- se traga y
 * devuelve el valor por defecto: quedarse sin tema no puede tumbar el panel.
 */
export function leerTemaGuardado(): Tema {
  try {
    const valor = window.localStorage.getItem(CLAVE_TEMA)
    return esTema(valor) ? valor : TEMA_POR_DEFECTO
  } catch {
    return TEMA_POR_DEFECTO
  }
}

export function guardarTema(tema: Tema): void {
  try {
    window.localStorage.setItem(CLAVE_TEMA, tema)
  } catch {
    // Sin persistencia el tema vale para esta pestana y ya. Preferible a
    // reventar al pulsar un boton.
  }
}

export function aplicarTema(tema: Tema): void {
  document.documentElement.setAttribute(ATRIBUTO_TEMA, tema)
}
